import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEye } from '@fortawesome/free-solid-svg-icons';

import AdminLayout from '../../Layouts/AdminLayout';

import PremioList from '../../Components/Manager/PremioList';

function App() {
    return (
        <AdminLayout>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                <div className="mt-4 grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                    <div className="col-span-12">
                        <div className="rounded-sm border border-stroke bg-white px-5 pb-2.5 pt-6 shadow sm:px-7.5 xl:pb-1">
                            <div className="flex items-center mb-6">
                                <h4 className="xl:text-xl font-bold text-black">
                                    Premios
                                </h4>
                            </div>
                            <div className="flex flex-col overflow-x-auto whitespace-nowrap">
                                <PremioList />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
}

export default App;